import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spin, Form, Input, Button, Checkbox, message } from "antd";
import {
  isAccessTokenExpired,
  refreshAccessToken,
  startSession,
} from "../../../services/tokenRefresh";
import AuthService from "../../../services/authentication.service";
import "./styles.scss";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import { httpService } from "../../../services/httpService.service";
import ExclamationMark from "../../../Assets/svg/exclamationMark.svg";
import { fileService } from "../../../services/fileService.service";

const LoginBox = ({ isShare }) => {
  const [loginLoading, setLoginLoading] = useState(false);
const [signUpLoading, setSignUpLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("email");
    const token = AuthService.getAccessToken();
    const clearStoredUser = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("tokenExpiresAt");
      localStorage.removeItem("refreshTokenExpiresAt");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("email");
      localStorage.removeItem("username");
      localStorage.removeItem("role");
      localStorage.removeItem("userID");
    };
    if (token && !isAccessTokenExpired(token)) {
      navigate("/dashboard/contracts");
    } else if (token && AuthService.getRefreshToken()) {
      // The access token only lasts 2 hours; a live refresh token still keeps
      // the user signed in.
      refreshAccessToken(token)
        .then(() => navigate("/dashboard/contracts"))
        .catch((error) => error?.sessionEnded && clearStoredUser());
    } else {
      clearStoredUser();
    }
  }, [navigate]);

  const saveImageAsBase64 = async (imageUrl, localStorageKey) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise((resolve, reject) => {
        reader.onloadend = () => {
          const base64data = reader.result;
          localStorage.setItem(localStorageKey, base64data);
          resolve(base64data);
        };
        reader.onerror = (error) => reject(error);
      });
    } catch (error) {
      console.error("Error saving image:", error);
      throw error;
    }
  };

  const setProfilePicture = async (fileKey) => {
    const url = `/FileData/getFileByFileKey?fileKey=${fileKey}`;
    await fileService.get(
      url,
      (response) => {
        const profilePictureUrl = response?.data?.data;
        saveImageAsBase64(profilePictureUrl, "profilePicture");
      },
      (error) => {
        // console.log(error);
      }
    );
  };

  const handleSignUp = () => {
  setSignUpLoading(true);
  // navigate("/sign-up");
};

  const handleLogin = (values) => {
    const { email, password } = values;

    setLoginLoading(true);

    const loginData = { email, password };

    httpService.post(
      "/api/Account/login",
      JSON.stringify(loginData),
      async (response) => {
        if (!response?.data?.confirmationCodeSent) {
          startSession(response.data);
          localStorage.setItem("userEmail", response.data.email);
          localStorage.setItem("username", response.data.fullName);

          localStorage.setItem("role", response.data.roles[0]?.roleName);
          localStorage.setItem("roleId", response.data.roles[0]?.id);
          localStorage.setItem("userID", response.data.id);
          localStorage.setItem(
            "profilePictureFileKey",
            response?.data?.profilePictureUrl || ""
          );
          response?.data?.profilePictureUrl &&
            setProfilePicture(response?.data?.profilePictureUrl);
          navigate("/dashboard/contracts");
        } else {
          navigate("/confirmationCode", { state: { email } });
        }
        setLoginLoading(false);
      },
      (error) => {
        const messageError = error?.errors?.[0]?.message || error?.message;
        if (
          messageError ===
          "User already has a pending confirmation code. Please check your email or resend code"
        ) {
          navigate("/confirmationCode", { state: { email } });
        } else {
          setPopupMessage({
            trigger: true,
            type: "danger",
            icon: ExclamationMark,
            title: "Oops! A problem has occurred!",
            text: messageError || "Error loging in, please try again later!",
          });
          setTimeout(() => {
            setPopupMessage({
              trigger: false,
            });
          }, 3000);
        }

        setLoginLoading(false);
      }
    );
  };

  const handleForgotPassword = () => {
    navigate("/forgotPassword");
  };

  return (
    <>
      <MessagePopUp
        trigger={popupMessage.trigger}
        type={popupMessage.type}
        icon={popupMessage.icon}
        messageTitle={popupMessage.title}
        messageText={popupMessage.text}
      />
      <div className="form-wrapper">
        <p>Welcome back!</p>
        {isShare ? (
          <h2>
            <b>TPM</b>ready
          </h2>
        ) : (
          <h2>TPMready Management System</h2>
        )}
        <Form
          onFinish={handleLogin}
          layout="vertical"
          style={{ width: "100%" }}
        >
          <Form.Item
            label="Email address"
            name="email"
            rules={[{ required: true, message: "Please input your email!" }]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item name="rememberMe" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
          <p
            className="forgotPassword text-start"
            onClick={handleForgotPassword}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
              width: "100%",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            Forgot your password?
          </p>
          <Form.Item style={{ width: "100%" }}>
            <Button
              className="addButtonTPM"
              htmlType="submit"
              loading={loginLoading}
              block
            >
              Sign in
            </Button>
          </Form.Item>
            <Form.Item style={{ width: "100%" }}>
            <Button
              className="inviteButtonTPM"
              href="/sign-up"
              onClick={handleSignUp}
              loading={signUpLoading}
              block
            >
              Sign up
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default LoginBox;
